import {
    ForecastObjectResponse,
} from 'app/requests/Forecast/Forecast.types'
import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    LeaseType, ProductType, RegionFirstLevel,
    TemperatureRange, LocationType,
} from 'app/enums/label.enums'
import {
    ForecastDataSpreadsheetColumnsConfig,
    ForecastSpreadsheetDataType,
} from '../../Forecast.types'

const getAccountFields = ({
    getAllowedValues,
    productType,
    tmpFields,
    disabled,
    onSpreadsheetChange,
    productTypeLabels,
    showForecast,
}: {
    getAllowedValues: (e: Record<string, string>) => Record<string, string>,
    productType: ProductType,
    tmpFields: ForecastDataSpreadsheetColumnsConfig,
    disabled: boolean,
    onSpreadsheetChange: (d: ForecastSpreadsheetDataType[]) => void,
    productTypeLabels: Record<string, string>,
    showForecast: boolean,
}): DTOCardFormField<keyof (ForecastObjectResponse & {
    spreadsheetData: ForecastSpreadsheetDataType
})>[] => {
    return [
        {
            title: 'Forecast Information',
            className: 'card',
            fields: [
                {
                    id: 'column1',
                    fields: [
                        {
                            name: 'validAsOf',
                            labelKey: 'Forecasts.validFrom',
                            componentName: 'DateTimeSelect',
                            disabled: true,
                        },
                        {
                            name: 'account',
                            componentName: 'AccountSelector',
                            labelKey: 'Forecasts.accountName',
                            disabled: true,
                        },
                    ],
                },
                {
                    id: 'column2',
                    fields: [
                        {
                            name: 'temperatureRange',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(TemperatureRange),
                            labelKey: 'Opportunities.temperatureRange',
                            disabled: true,
                        },
                        {
                            name: 'leaseType',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(LeaseType),
                            labelKey: 'Forecasts.leaseType',
                            disabled: true,
                        },
                    ],
                },
                {
                    id: 'column3',
                    fields: [
                        {
                            name: 'originAirportRegionFirstLevel',
                            labelKey: 'RegionalGroups.originRegion',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(RegionFirstLevel),
                            disabled: true,
                        },
                        {
                            name: 'originAirport',
                            componentName: 'LocationObjectSelector',
                            filterLocationType: LocationType.AIRPORT,
                            labelKey: 'Forecasts.originAirport',
                            disabled: true,
                        },
                    ],
                },
                {
                    id: 'column4',
                    fields: [
                        {
                            name: 'destinationAirportRegionFirstLevel',
                            labelKey: 'RegionalGroups.destinationRegion',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(RegionFirstLevel),
                            disabled: true,
                        },
                        {
                            name: 'destinationAirport',
                            componentName: 'LocationObjectSelector',
                            filterLocationType: LocationType.AIRPORT,
                            labelKey: 'Forecasts.destinationAirport',
                            disabled: true,
                        },
                    ],
                },
            ],
        },
        {
            title: `Forecast by Product Type ${productTypeLabels[productType]}`,
            className: 'card',
            hidden: !showForecast,
            fields: [{
                name: 'spreadsheetData',
                componentName: 'SingleForecastSpreadsheet',
                disabled,
                tmpFields,
                onSpreadsheetChange,
            }],
        },
    ]
}

export default getAccountFields
